<script>
import ShowStatus from '@/components/ShowStatus.vue'
import auth from '@/utils/auth'

export default {
  name: 'EquipamentoStatusCard',
  components: { ShowStatus },
  props: {
    equipamento: {
      type: Object,
      required: true,
    },
    localId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggleCard: false,
    }
  },
  computed: {
    isAdmin: auth.isAdmin,
  },
  methods: {
    pushToEquipamentoRoute(equipamentoId) {
      this.$router.push({
        name: 'LocalDetalhe',
        params: { localId: this.localId },
        query: { e: equipamentoId },
      })
    },
    pushToPainel(equipamentoId) {
      this.$router.push(
        `/local/${this.localId}/equipamento/${equipamentoId}/editar`
      )
    },
    rightClick() {
      this.toggleCard = true
    },
  },
}
</script>

<template>
  <md-card
    style="margin: 0"
    @contextmenu.native.prevent="() => rightClick()"
    @click.native="() => pushToEquipamentoRoute(equipamento.id)"
  >
    <div
      v-if="equipamento.sensores.filter((e) => e.severity !== 0).length !== 0"
      class="badge"
    >
      <div class="inner_badge">
        {{ equipamento.sensores.filter((e) => e.severity !== 0).length }}
      </div>
    </div>
    <md-ripple>
      <div style="position: absolute">
        <md-menu md-direction="bottom-start" :md-active.sync="toggleCard">
          <md-menu-content>
            <md-menu-item
              v-if="isAdmin"
              @click="() => pushToPainel(equipamento.id)"
            >
              Painel
            </md-menu-item>

            <md-menu-item @click="() => pushToEquipamentoRoute(equipamento.id)">
              Gráficos
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <div class="md-layout m-2">
        <div class="md-layout-item md-size-65">
          <div>
            {{ equipamento.nome }}
          </div>
        </div>

        <div class="md-layout-item">
          <show-status
            :value="equipamento.severity"
            :config="{
              0: { label: 'Ok', color: '#4CAF50' },
              1: { label: 'Travado', color: '#FF9800' },
              2: { label: 'Critico', color: '#F44336' },
            }"
          />
        </div>
      </div>
    </md-ripple>
  </md-card>
</template>

<style scoped lang="scss">
.badge {
  position: absolute;
  border-radius: 50%;
  top: -25%;
  right: -3%;
  z-index: 999 !important;

  $size: 25px;

  height: $size;
  width: $size;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background-color: red;

  align-items: center;
  display: flex;
}

.inner_badge {
  font-size: 12px;
  text-align: center;
  flex: 1;

  color: white;
  font-weight: bold;
}
</style>
